// extracted by mini-css-extract-plugin
module.exports = {"DateRageStyle":"RgYPnu0UeMcyARADRS9bu"};